import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import ProductListPage from '../../components/ProductListPage/ProductListPage';
import CatalogHeader from '../../components/CatalogHeader/CatalogHeader';
import { SALES_CHANNELS, SALES_CHANNELS_GROUP } from '../../constants';
import withResponsiveWrapper from '../../decorators/withResponsiveWrapper';
import withIntersectionObserver from '../../decorators/withIntersectionObserver';
import { getProducts } from '../../actions/shop';

import s from './DisplayCatalog.scss';
import DEFAULT_FILTERS from './defaultFilters';
import { isProductPorInPortal } from '../../helpers';

const DisplayCatalog = ({
  page,
  shop,
  currency,
  logo,
  mode,
  isBottom,
  dispatch,
  salesChannelId,
  salesChannelGroup,
  ...props
}) => {
  const { nextPage, infiniteLoad, loading } = shop;
  useEffect(() => {
    if (isBottom && !loading && infiniteLoad) {
      dispatch(
        getProducts({
          page: nextPage,
          id: salesChannelId,
          params: DEFAULT_FILTERS,
        }),
      );
    }
  }, [isBottom, infiniteLoad, loading, nextPage]);

  // temp solution to hide POR giftcards in portal same as in shop page
  const filteredProducts = shop?.data?.filter(
    item => !isProductPorInPortal(item.productTitle, salesChannelGroup),
  );

  const isPortal = salesChannelGroup === SALES_CHANNELS_GROUP.PORTAL;
  const pageName = isPortal && `portal_${salesChannelId}`;
  const banner = isPortal
    ? {
        desktop: page.byName[pageName]?.portalBannerDesktop,
        mobile: page.byName[pageName]?.portalBannerMobile,
        alt: page?.pageName || '',
        link: page?.pageBannerLink,
      }
    : undefined;

  return (
    shop.data && (
      <div className={s.root}>
        <CatalogHeader logo={logo} />
        <ProductListPage
          data={filteredProducts}
          filters={shop.filters}
          loading={shop.loading}
          ordering={shop.ordering}
          totalItems={shop.totalItems}
          banner={[banner]}
          className={s.productList}
          salesChannelId={salesChannelId}
          catalogMode
          isDesktop
          currency={currency}
          mode={mode}
          {...props}
        />
      </div>
    )
  );
};

const mapState = state => ({
  page: state.page,
  shop: state.shop,
  currency: state.intl.currency,
  salesChannelId: state.config.salesChannelId,
  salesChannelGroup: state.config.salesChannel.group,
});

export default compose(
  withResponsiveWrapper(),
  withIntersectionObserver(1),
  withStyles(s),
  connect(mapState),
)(DisplayCatalog);

DisplayCatalog.propTypes = {
  page: PropTypes.shape().isRequired,
  shop: PropTypes.shape().isRequired,
  logo: PropTypes.string,
  salesChannelId: PropTypes.string,
  salesChannelGroup: PropTypes.string,
  isBottom: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
};

DisplayCatalog.defaultProps = {
  logo: undefined,
  salesChannelId: SALES_CHANNELS.REDEEM,
  salesChannelGroup: SALES_CHANNELS_GROUP.WEBSITE,
};
